import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { HttpClientModule } from '@angular/common/http';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from 'primeng/divider';
import { KnobModule } from 'primeng/knob';
import { UsuarioDashBoardRoutingModule } from './usuario-dashboard-routing.module';
import { UsuarioDashBoardComponent } from './usuario-dashboard.component';

@NgModule({
 
  imports: [
    CommonModule,    
    UsuarioDashBoardRoutingModule,
    TableModule,
    HttpClientModule,
    ButtonModule,
    InputTextModule,
    TooltipModule,
    KnobModule,
    DividerModule
  ],
  declarations: [
    UsuarioDashBoardComponent
  ]
})
export class UsuarioDashBoardModule { }
